import { DirectiveOptions } from "vue";
import { DirectiveBinding } from "vue/types/options";

import { SnowplowService } from "@/services/SnowplowService";

interface ISnowplowPayload {
  event: string;
}

function buildBindingPayload(binding: DirectiveBinding, vnode: any): ISnowplowPayload {
  if (binding.modifiers.react) {
    const payload = { event: binding.value.event };
    return binding.value.props.reduce((obj: any, prop: string) => {
      obj[prop] = vnode.context[prop];
    }, payload);
  } else {
    return binding.value;
  }
}

export const vTrack: DirectiveOptions = {
  bind(el: HTMLElement, binding: DirectiveBinding, vnode: any) {
    if (binding.modifiers.enter) {
      el.addEventListener("keyup", (event: KeyboardEvent) => {
        if (event.key === "Enter" && (event.target as HTMLInputElement).value.replace(/\r?\n|\r/g, "").trim() !== "") {
          SnowplowService.track(binding.value.event, {
            ...binding.value
          });
        }
      });
    } else {
      const payload = buildBindingPayload(binding, vnode);

      el.addEventListener("click", (event: MouseEvent) => {
        SnowplowService.track(payload.event, payload);
      });

      if (el.attributes.getNamedItem("href")) {
        el.addEventListener("contextmenu", () => {
          SnowplowService.track(payload.event, payload);
        });
      }
    }
  }
};
